<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "floor",
      key: "id",
      url: {
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "楼宇名称",
          name: "buildingId",
          value: "",
          type: "select",
          dropList: [],
          width: "400px",
          rules: [{ required: true}],
        },
        {
          label: "楼层名称",
          name: "floorName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },

      ],
      forms: {},
    };
  },
  created() {
this.initData()
  },
  mounted() {
  },
  methods: {

    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load('/admin/system/floor/listBuilding', {}).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.buildingName;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "buildingId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
              .load(
                  `/admin/system/floor/addFloor`,
                  q,
                  "POST"
              )
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
        }
      });
    },

  },
};
</script>
